import styles from './NotFoundBlock.module.css';
import Icon from '../Icon';

export default function NotFoundBlock({ type = 'news' }) {
  const isFilterType = type === 'filter';

  return (
    <div className={styles.wrapper}>
      <Icon
        name={isFilterType ? 'filterNotFoundIcon' : 'newsNotFoundIcon'}
        width='40'
        height='40'
      />
      <h4 className='text_headers_h4'>
        {isFilterType ? 'Ничего не нашли' : 'Такие новости еще не написаны'}
      </h4>
      <p className='text_body_b2'>
        {isFilterType
          ? 'Стоит попробовать перенастроить фильтры'
          : 'К сожалению, в этом разделе ничего нет'}
      </p>
    </div>
  );
}